<template>
  <Layout>
    <div class="row">
      <div class="outBox">
        <div class="box-1">
          <div class="chat-messages">
            <div id="msglist" @scroll="handleScroll">
              <div
                v-for="(message, index) in chatList"
                :key="message.id"
                :id="'msg-' + message.id"
              >
                <!-- 用户消息（右侧蓝色气泡） -->
                <div
                  v-if="message.isSelf"
                  class="chat-right-box flex-depart-right-top"
                >
                  <div class="chat-content chat-content-right">
                    <div class="user-name n-right">我</div>
                    <div class="content-box-comm content-box-right">
                      <div class="user-message-content">{{ message.content }}</div>
                    </div>
                    <!-- 复制按钮 -->
                    <div
                      class="copy-btn-wrapper"
                      @click="copyMessage(message.content)"
                    >
                      <span>复制</span>
                    </div>
                  </div>
                  <div class="tx">
                    <img :src="myTx" />
                  </div>
                </div>
                <!-- AI 消息（左侧白色气泡 + markdown 流式渲染） -->
                <div v-else class="chat-left-box flex-depart-top">
                  <div class="tx tx-left">
                    <img
                      src="https://ossfastmake.xlkapp.com/12jielong/lsyJL/chat-AI.png"
                      alt=""
                    />
                  </div>
                  <div class="chat-content">
                    <div class="user-name n-left">智能助手</div>
                    <div class="content-box-comm content-box-left">
                      <div
                        class="content-txt markdown-rich-text"
                        :class="{
                          'is-thinking-placeholder': message.isThinkingPlaceholder,
                        }"
                        v-html="message.richTextContent || message.content"
                      ></div>

                      <!-- 活动创建成功 - 查看详情按钮 -->
                      <div
                        v-if="
                          showViewActivityBtnIndex === index && showViewActivityBtn
                        "
                        class="view-activity-btn"
                        @click="viewActivityDetail"
                      >
                        <span class="view-activity-icon">✅</span>
                        <span>查看活动详情</span>
                        <i class="el-icon-arrow-right view-activity-arrow"></i>
                      </div>

                      <!-- 草稿待确认 - 确认创建 / 重新生成 按钮并排 -->
                      <!-- 点击后不消失，AI 响应期间（isRequestPending）置灰禁用防连点 -->
                      <div
                        v-if="showConfirmBtnIndex === index && showConfirmBtn"
                        class="draft-action-btns"
                      >
                        <div
                          class="confirm-create-btn"
                          :class="{ 'draft-btn-disabled': isRequestPending }"
                          @click="confirmCreateDraft"
                        >
                          <span>确认创建</span>
                        </div>
                        <div
                          class="regenerate-btn"
                          :class="{ 'draft-btn-disabled': isRequestPending }"
                          @click="regenerateDraft"
                        >
                          <span>重新生成</span>
                        </div>
                      </div>

                      <!-- 第一步的提示：首条 AI 消息下的快捷建议 -->
                      <div class="eachOne-box" v-if="index === 0">
                        <div
                          class="each-item flex-depart-left-center"
                          v-for="(title, index1) in createTextTemplate"
                          :key="index1"
                        >
                          <span class="aPoint">●</span>
                          <div
                            class="point-after flex-depart-left-center"
                            :class="{ 'is-disabled': isActionLocked }"
                            @click="addQuickMessage(title)"
                          >
                            <div class="pa-txt">{{ title }}</div>
                            <i class="el-icon-arrow-right quick-arrow"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 输入区域 -->
        <div class="input-container">
          <div class="input-wrapper">
            <el-input
              v-model="inputText"
              type="textarea"
              :autosize="{ minRows: 1, maxRows: 4 }"
              maxlength="1000"
              placeholder="请输入内容"
              :disabled="isActionLocked"
              class="text-input"
              @keydown.enter.native="onEnterPress"
            ></el-input>
            <el-button
              type="primary"
              class="send-btn"
              style="background-color: #1877ff"
              :disabled="isActionLocked"
              @click="handleSend"
              >{{ isRequestPending ? "发送中..." : "发送" }}</el-button
            >
          </div>
          <div class="ai-tip">
            <span class="ai-tip-text">本服务为AI生成内容，仅供参考</span>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config";
import { SOCKET_AI_URL } from "@/utils/config/commonUrl.js";
import copyrightConfig from "@/utils/config/changeCopyright.js";
import WebSocketManager from "../../../../utils/WebSocketManager";
import Layout from "../../layouts/main";
import { getMyInfo } from "@/utils/api/user.js";
import { renderAiMarkdown } from "@/utils/aiMarkdown.js";
import { getOrCreateAiConversationId } from "@/utils/aiConversation.js";
import { isValidAiUserId } from "@/utils/aiUserId.js";
import {
  extractAiActivityId,
  extractAiActivityKey,
  stripAiActivityMarkers,
} from "@/utils/aiActivityMarker.js";
import { isCurrentAiSocketConnection } from "@/utils/aiSocketConnection.js";

export default {
  page: {
    title: "AI发布接龙",
    meta: [{ name: "description", content: appConfig.description }],
  },
  name: "AIPublishJieLong",
  components: { Layout },
  data() {
    return {
      chatList: [], // 聊天记录列表
      inputText: "", // 输入框文本
      socketTask: null, // WebSocket 实例
      serverUrl: "", // WS 连接地址（进入页面时由 buildServerUrl() 生成，确保 token 就绪）
      conversationId: "", // 文字和重连共用的会话标识
      threadId: null, // 会话 id（握手后从 session 消息拿到，后续 chat 复用）
      finalMessage: "", // 当前完整的消息
      streamingMessage: "", // 用于流式显示的当前消息
      thinkingPlaceholderText: "AI 正在努力识别中",
      lastMessageIndex: -1, // 最后一条流式消息的索引
      messageIdSeed: 0,
      showConfirmBtn: false, // 控制「确认创建/重新生成」按钮显示
      showConfirmBtnIndex: 0, // 按钮显示在哪个消息索引
      isCreating: false, // 创建中状态（保留与小程序一致的锁字段）
      isRequestPending: false, // AI 响应处理中
      showViewActivityBtn: false, // 是否显示"查看活动详情"按钮
      showViewActivityBtnIndex: 0, // 按钮显示在哪个消息索引
      createdActivityId: null, // AI 创建成功的活动 ID
      createdActivityKey: null, // AI 创建成功的活动 key（alias，详情页跳转优先使用）
      createTextTemplate: [
        "生成一个每日英语阅读打卡",
        "生成一个签售会报名接龙",
        "生成一个签到打卡",
      ], // 默认进入时提示的文案
      retryTimer: null, // 重试计时器
      retryAttempt: 0,
      retryBaseDelayMs: 1000,
      retryMaxDelayMs: 30000,
      retryJitterRatio: 0.2,
      isConnecting: false, // 是否正在连接中
      socketConnectAttempt: null, // 当前连接 attempt；用于忽略旧 socket 的迟到回调
      isPageUnloading: false,
      myTx:
        "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/lsyJL/chat-user.png",
      // 滚动容器
      isFirstLoad: true, // 是否首次加载
      isScrolling: false, // 是否正在滚动
      scrollTimer: null, // 滚动轮询定时器
      lastMessageLength: 0, // 记录上一条消息的长度
      isAutoScroll: true, // 是否自动滚动
      lastScrollTop: 0, // 上次滚动位置
      isManualScroll: false, // 是否手动滚动
      firstSee: true,
    };
  },
  computed: {
    // 一轮 AI 请求进行中：输入发送、快捷建议全部禁用
    isActionLocked() {
      return this.isRequestPending || this.isCreating;
    },
  },
  created() {
    this.isPageUnloading = false;
    const profilePhoto = localStorage.getItem("myProfilePhoto");
    if (profilePhoto) {
      this.myTx = profilePhoto;
    }
    // 欢迎语立即渲染：不等登录补齐和 WS 握手，进入页面即可见
    this.addMessage(
      " 你好，我是智能AI助手小V，您可以输入文字告诉我您对报名、接龙、打卡、信息收集的需求，我为您生成适合的接龙内容。有什么可以帮你吗？",
      false
    );
    this.bootstrapSession();
  },
  beforeDestroy() {
    this.isPageUnloading = true;
    this.socketConnectAttempt = null;
    this.isConnecting = false;
    // 清除滚动轮询定时器
    this.stopScrollPolling();

    // 不再直接关闭 WebSocket，而是通过管理器关闭
    if (this.socketTask) {
      const closingServerUrl = this.serverUrl;
      try {
        // 从存储列表中移除当前连接；存储异常不能阻断 socket 和定时器清理。
        this.writeSocketTaskList(
          this.readSocketTaskList().filter(
            (item) => item.url !== closingServerUrl
          )
        );
      } catch (error) {
        console.warn("[AI] 清理 WebSocket 连接记录失败，继续关闭连接");
      } finally {
        WebSocketManager.closeConnection(closingServerUrl);
        this.socketTask = null;
      }
    }
    // 清除重试定时器
    if (this.retryTimer) {
      clearTimeout(this.retryTimer);
      this.retryTimer = null;
    }
    this.retryAttempt = 0;
  },
  methods: {
    showToast(title) {
      this.$message(title);
    },
    // 进入页面：补齐 userId（缺失时调 /mine/getMyInfo），再建 WS 连接
    async bootstrapSession() {
      const token = localStorage.getItem("token");
      if (!token) {
        this.showToast("登录异常，请重进");
        return;
      }
      if (!isValidAiUserId(localStorage.getItem("userId"))) {
        const ready = await this.ensureUserId();
        if (!ready) {
          this.showToast("登录异常，请重进");
          return;
        }
      }
      this.refreshConversationSession();
      this.serverUrl = this.buildServerUrl();
      this.connectSocket();
    },
    // WS 四要素中的 userId：PC 端登录后不一定落过 localStorage，缺时补拉一次
    async ensureUserId() {
      try {
        const res = await getMyInfo({});
        if (res && res.status === 1 && res.data) {
          const userId = res.data.user_id || res.data.id || "";
          if (userId) {
            localStorage.setItem("userId", String(userId));
          }
          if (res.data.nickname) {
            localStorage.setItem("name", res.data.nickname);
          }
          return Boolean(userId);
        }
      } catch (error) {
        console.error("[AI] 获取用户信息失败:", error);
      }
      return false;
    },
    readSocketTaskList() {
      try {
        return JSON.parse(localStorage.getItem("socketTaskList")) || [];
      } catch (error) {
        return [];
      }
    },
    writeSocketTaskList(list) {
      try {
        localStorage.setItem("socketTaskList", JSON.stringify(list));
      } catch (error) {
        console.warn("[AI] 写入 WebSocket 连接记录失败:", error);
      }
    },
    refreshConversationSession(touch = true) {
      const previousConversationId = this.conversationId;
      this.conversationId = getOrCreateAiConversationId({ touch });
      if (
        previousConversationId &&
        previousConversationId !== this.conversationId
      ) {
        console.log("[AI] 会话标识已轮换");
      }
      return previousConversationId !== this.conversationId;
    },
    reconnectForCurrentConversation() {
      const previousServerUrl = this.serverUrl;
      // 先让旧 attempt 失效，close 产生的异步回调不得操作新连接。
      this.socketConnectAttempt = null;
      this.isConnecting = false;
      if (previousServerUrl) {
        WebSocketManager.closeConnection(previousServerUrl);
      }
      this.socketTask = null;
      this.serverUrl = this.buildServerUrl();
      this.connectSocket();
    },
    ensureTextSessionReady() {
      if (this.refreshConversationSession(true)) {
        this.reconnectForCurrentConversation();
        this.showToast("会话已更新，请重新发送");
        return false;
      }
      if (!this.socketTask) {
        this.showToast("连接未就绪，请稍后重试");
        return false;
      }
      return true;
    },
    // 构造当前 Agent 后端 WS 地址，进入页面时带上当前发布者信息。
    buildServerUrl() {
      const token = localStorage.getItem("token") || "";
      // 历史版本可能存入字符串 "undefined"，视为缺失，避免拼出 userId=undefined
      const storedUserId = localStorage.getItem("userId") || "";
      const userId = isValidAiUserId(storedUserId) ? storedUserId : "";
      const appId = copyrightConfig.AppID || "";
      const publisher = localStorage.getItem("name") || "";
      if (!token) {
        console.warn("[AI] token 缺失，无法连接 Agent 后端");
        return "";
      }
      if (!userId) {
        console.warn("[AI] userId 缺失，无法连接 Agent 后端");
        return "";
      }
      if (!appId) {
        console.warn("[AI] appId 缺失，无法连接 Agent 后端");
        return "";
      }
      if (!this.conversationId) {
        console.warn("[AI] conversationId 缺失，无法连接 Agent 后端");
        return "";
      }
      // userId 由前端透传（来自登录态），后端不反查
      return (
        SOCKET_AI_URL +
        "chatAi" +
        "?access-token=" +
        encodeURIComponent(token) +
        "&userId=" +
        encodeURIComponent(String(userId)) +
        "&appid=" +
        encodeURIComponent(String(appId)) +
        "&publisher=" +
        encodeURIComponent(String(publisher)) +
        "&conversationId=" +
        encodeURIComponent(this.conversationId)+
        "&client=pc"

      );
    },
    // 当前 Agent 后端使用文本流协议：客户端直接发送用户输入文本
    sendChat(message) {
      if (!this.ensureTextSessionReady()) return false;
      try {
        this.socketTask.send(String(message));
      } catch (error) {
        console.error("发送消息时出错:", error);
        this.showToast("发送失败，请重试");
        return false;
      }
      return true;
    },
    handleScroll(e) {
      const scrollTop = e.target.scrollTop;
      const scrollHeight = e.target.scrollHeight;
      const clientHeight = e.target.clientHeight;

      const isBottom = Math.abs(scrollHeight - scrollTop - clientHeight) <= 10;

      // 判断是否是手动向上滚动（阅读历史）
      if (scrollTop < this.lastScrollTop) {
        this.isManualScroll = true;
        this.isAutoScroll = false;
      } else if (scrollTop > this.lastScrollTop) {
        // 向下滚动且已回到底部、滑动距离超过阈值时恢复自动滚动
        if (isBottom) {
          const scrollDistance = scrollTop - this.lastScrollTop;
          if (scrollDistance > 50) {
            this.isManualScroll = false;
            this.isAutoScroll = true;
            this.$nextTick(() => {
              this.scrollToBottom();
            });
          }
        }
      }

      this.lastScrollTop = scrollTop;
      this.isScrolling = !isBottom;
    },
    // 检查当前 WebSocket 连接数量（纯本地存储检查）
    checkSocketLimit() {
      try {
        // 获取当前 WebSocket 连接数量
        const socketTaskList = this.readSocketTaskList();

        // 清理过期的连接（超过30分钟的连接）
        const now = Date.now();
        const validConnections = socketTaskList.filter((conn) => {
          return now - conn.timestamp < 30 * 60 * 1000; // 30分钟
        });

        // 更新存储的有效连接列表
        this.writeSocketTaskList(validConnections);

        // 如果连接数量已达到上限，关闭最早的连接
        if (validConnections.length >= 5) {
          // 按时间戳排序，移除最早的连接
          validConnections.sort((a, b) => a.timestamp - b.timestamp);
          const oldestConn = validConnections.shift();

          if (oldestConn) {
            WebSocketManager.closeConnection(oldestConn.url);
            this.writeSocketTaskList(validConnections);
          }
        }
        return Promise.resolve(true);
      } catch (error) {
        console.error("检查WebSocket连接限制时出错:", error);
        return Promise.resolve(false);
      }
    },
    async connectSocket() {
      if (this.refreshConversationSession()) {
        this.serverUrl = this.buildServerUrl();
      }
      // 如果正在连接中，则不重复连接
      if (this.isConnecting) return;
      // serverUrl 为空（四要素缺失）时直接提示，避免空 url 连接失败
      if (!this.serverUrl) {
        this.showToast("登录异常，请重进");
        return;
      }
      this.isConnecting = true;
      const connectionAttempt = {};
      this.socketConnectAttempt = connectionAttempt;
      const connectionUrl = this.serverUrl;
      let connectionSocket = null;
      const isCurrentConnection = () =>
        this.socketConnectAttempt === connectionAttempt &&
        !this.isPageUnloading &&
        isCurrentAiSocketConnection({
          currentUrl: this.serverUrl,
          currentSocket: this.socketTask,
          connectionUrl,
          connectionSocket,
        });

      try {
        // 先检查是否有可用的现有连接（30 分钟内同 URL 记录）
        const socketTaskList = this.readSocketTaskList();
        const existingConnection = socketTaskList.find((conn) => {
          return (
            conn.url === connectionUrl &&
            Date.now() - conn.timestamp < 30 * 60 * 1000
          );
        });

        // 尝试复用现有连接
        if (existingConnection) {
          try {
            const existingSocket = WebSocketManager.getExistingConnection(
              connectionUrl
            );
            if (existingSocket) {
              connectionSocket = existingSocket;
              this.socketTask = existingSocket;

              // 更新连接时间戳
              this.writeSocketTaskList(
                socketTaskList.map((conn) => {
                  if (conn.url === connectionUrl) {
                    return { ...conn, timestamp: Date.now() };
                  }
                  return conn;
                })
              );

              this.isConnecting = false;
              return;
            }
          } catch (error) {
            console.error("复用连接失败:", error);
          }
        }
        // 如果没有可用连接，检查连接数量限制
        const canConnect = await this.checkSocketLimit();
        if (!canConnect) {
          this.isConnecting = false;
          this.retryConnect("network unavailable");
          return;
        }
        // 使用 WebSocket 管理器获取连接
        const resolvedSocket = await WebSocketManager.getConnection(
          connectionUrl,
          {
            onFail: (err) => {
              if (!isCurrentConnection()) return;
              this.removeThinkingPlaceholder();
              this.finishRequest();
              this.socketTask = null;
              this.isConnecting = false;
              console.error("WebSocket 连接失败:", err);
              this.retryConnect("connect fail");
            },
            onOpen: () => {
              if (!isCurrentConnection()) return;
              this.resetReconnectBackoff();
              // 连接成功后，将新连接添加到存储列表
              if (this.socketTask) {
                const socketTaskList = this.readSocketTaskList();
                socketTaskList.push({
                  id: Date.now().toString(),
                  url: connectionUrl,
                  timestamp: Date.now(),
                });
                this.writeSocketTaskList(socketTaskList);
              }
            },
            onMessage: (res) => {
              if (!isCurrentConnection()) return;
              const payload =
                typeof res.data === "string" ? res.data : String(res.data || "");
              if (!payload) return;
              // 忽略服务端心跳,仅用于保持连接不空闲
              if (payload === '{"type":"ping"}') return;
              if (payload === "[complete]") {
                this.handleRoundDone();
                return;
              }

              // 兼容 JSON 控制消息；当前后端正常返回文本片段
              let msg;
              try {
                msg = JSON.parse(payload);
              } catch (e) {
                this.appendToken(payload);
                return;
              }
              if (!msg || typeof msg !== "object" || !msg.type) {
                this.appendToken(payload);
                return;
              }
              switch (msg.type) {
                case "session":
                  // 握手后下发会话 id，后续 chat 复用
                  this.threadId = msg.threadId;
                  break;
                case "token":
                  // 流式文本片段（增量），累加显示
                  this.appendToken(msg.content);
                  break;
                case "tool_start":
                  // 工具调用开始（可在此做"正在操作…"提示，暂略）
                  break;
                case "route":
                  // supervisor 路由通知，对用户无意义，忽略
                  break;
                case "done":
                  // 一轮正常结束
                  this.handleRoundDone();
                  break;
                case "error":
                  this.removeThinkingPlaceholder();
                  this.finishRequest();
                  this.showToast(msg.message || "服务异常");
                  break;
                default:
                  console.warn("[AI] 未识别的消息类型:", msg.type, msg);
              }
            },
            onClose: (res) => {
              if (!isCurrentConnection()) return;
              this.removeThinkingPlaceholder();
              this.finishRequest();
              // 清理连接信息
              this.writeSocketTaskList(
                this.readSocketTaskList().filter(
                  (item) => item.url !== connectionUrl
                )
              );
              this.socketTask = null;

              // 只有在非正常关闭时才重连
              if (!res || res.code !== 1000) {
                this.retryConnect();
              }
            },
            onError: (err) => {
              if (!isCurrentConnection()) return;
              this.removeThinkingPlaceholder();
              this.finishRequest();
              console.error("WebSocket 连接错误:", err);
              this.retryConnect("socket error");
            },
          }
        );

        connectionSocket = resolvedSocket;
        if (
          this.socketConnectAttempt !== connectionAttempt ||
          this.isPageUnloading ||
          this.serverUrl !== connectionUrl
        ) {
          WebSocketManager.closeConnection(connectionUrl);
          return;
        }
        this.socketTask = resolvedSocket;

        this.isConnecting = false;
      } catch (error) {
        if (this.socketConnectAttempt !== connectionAttempt) return;
        console.error("连接过程中发生错误:", error);
        this.isConnecting = false;
        this.retryConnect("connect exception");
      }
    },
    getReconnectDelay() {
      const rawDelay = this.retryBaseDelayMs * Math.pow(2, this.retryAttempt);
      const cappedDelay = Math.min(rawDelay, this.retryMaxDelayMs);
      const jitterRange = cappedDelay * this.retryJitterRatio;
      return Math.round(
        cappedDelay - jitterRange + Math.random() * jitterRange * 2
      );
    },
    resetReconnectBackoff() {
      if (this.retryTimer) {
        clearTimeout(this.retryTimer);
        this.retryTimer = null;
      }
      this.retryAttempt = 0;
    },
    retryConnect(reason = "socket closed") {
      if (this.isPageUnloading || !this.serverUrl) return;
      // onError 和 onClose 可能连续触发，同一轮异常只排一个重连任务。
      if (this.retryTimer) return;
      const delay = this.getReconnectDelay();
      this.retryAttempt += 1;
      console.warn(
        `[AI] WebSocket ${reason}，${delay}ms 后重连，第 ${this.retryAttempt} 次`
      );
      this.retryTimer = setTimeout(() => {
        this.retryTimer = null;
        this.connectSocket();
      }, delay);
    },
    closeSocket() {
      if (this.socketTask) {
        WebSocketManager.closeConnection(this.serverUrl);
        this.socketTask = null;
      }
    },
    // UI 交互方法
    onEnterPress(e) {
      // Shift+Enter 换行；输入法组合中的 Enter 不发送
      if (e.shiftKey || e.isComposing) return;
      e.preventDefault();
      this.handleSend();
    },
    handleSend() {
      if (this.isActionLocked) return;
      const message = this.inputText.trim();
      if (!message) return;
      if (!this.socketTask) {
        this.showToast("连接未就绪，请稍后重试");
        return;
      }
      this.startRequest();
      this.addMessage(message, true);
      this.inputText = "";
      this.prepareThinkingPlaceholder();
      if (!this.sendChat(message)) {
        this.removeThinkingPlaceholder();
        this.finishRequest();
        return;
      }
      // 重置滚动状态
      this.isManualScroll = false;
      this.isAutoScroll = true;
      this.$nextTick(() => {
        this.scrollToBottom();
      });
    },
    addMessage(content, isSelf, type = "text", audioUrl = "", options = {}) {
      const isAiText = !isSelf && type === "text";
      const isThinkingPlaceholder = Boolean(options.isThinkingPlaceholder);
      this.chatList.push({
        id: this.createMessageId(),
        content,
        // 占位消息不渲染 markdown；AI 文本消息渲染为富文本
        richTextContent:
          isAiText && !isThinkingPlaceholder ? renderAiMarkdown(content) : "",
        isThinkingPlaceholder,
        isSelf,
        time: this.getCurrentTime(),
        type: type,
        audioUrl: audioUrl,
        isPlay: false,
        audioDuration: 0,
      });
      this.scrollToBottom();
    },
    createMessageId() {
      this.messageIdSeed += 1;
      return `${Date.now()}-${this.messageIdSeed}`;
    },
    isThinkingMessageActive() {
      if (
        this.lastMessageIndex < 0 ||
        this.lastMessageIndex >= this.chatList.length
      ) {
        return false;
      }
      const message = this.chatList[this.lastMessageIndex];
      return Boolean(message && message.isThinkingPlaceholder);
    },
    prepareThinkingPlaceholder() {
      this.streamingMessage = "";
      this.addMessage(this.thinkingPlaceholderText, false, "text", "", {
        isThinkingPlaceholder: true,
      });
      this.lastMessageIndex = this.chatList.length - 1;
    },
    removeThinkingPlaceholder() {
      if (!this.isThinkingMessageActive()) return;
      this.chatList.splice(this.lastMessageIndex, 1);
      this.streamingMessage = "";
      this.lastMessageIndex = -1;
      this.stopScrollPolling();
    },
    scrollToBottom() {
      if (this.firstSee == true) {
        this.firstSee = false;
        return false;
      }
      // 如果用户正在阅读历史（手动滚动），不执行自动滚动
      if (this.isManualScroll) return;

      this.$nextTick(() => {
        const msgList = document.getElementById("msglist");
        if (msgList) {
          setTimeout(() => {
            msgList.scrollTop = msgList.scrollHeight;
            // 如果第一次滚动失败，尝试再次滚动
            if (msgList.scrollTop === 0) {
              setTimeout(() => {
                msgList.scrollTop = msgList.scrollHeight;
              }, 100);
            }
          }, 0);
          this.isFirstLoad = false;
          this.isScrolling = false;
        }
      });
    },
    getCurrentTime() {
      const now = new Date();
      return `${now.getHours().toString().padStart(2, "0")}:${now
        .getMinutes()
        .toString()
        .padStart(2, "0")}`;
    },
    // 流式 token 片段累加：首片建新消息，后续更新最后一条
    appendToken(content) {
      if (!content) return;
      // 判断是否需要自动滚动
      const shouldAutoScroll = this.isFirstLoad || !this.isScrolling;
      if (this.lastMessageIndex === -1) {
        // 无占位消息：第一片 token 直接建新消息
        this.streamingMessage = content;
        this.addMessage(this.streamingMessage, false, "text", "");
        this.lastMessageIndex = this.chatList.length - 1;
      } else if (this.isThinkingMessageActive()) {
        // 占位消息激活：把占位转成真实内容。
        // 关键：第一片真实 token 进来时 streamingMessage 必须从 content 开始累加，
        // 不能残留旧值，否则开头内容会丢失。
        this.streamingMessage = this.streamingMessage
          ? this.streamingMessage + content
          : content;
        if (!this.streamingMessage.trim()) {
          return;
        }
        this.updateLastMessage(this.streamingMessage, {
          isThinkingPlaceholder: false,
        });
      } else {
        this.streamingMessage += content;
        this.updateLastMessage(this.streamingMessage);
      }
      if (shouldAutoScroll) {
        this.startScrollPolling();
      }
    },
    // 一轮对话正常结束（收到 done / [complete]）后的收尾：固化文本 + 提取 activityId
    handleRoundDone() {
      const hasOnlyThinkingPlaceholder =
        this.isThinkingMessageActive() && !this.streamingMessage.trim();
      if (hasOnlyThinkingPlaceholder) {
        this.removeThinkingPlaceholder();
        this.finishRequest();
        this.$nextTick(() => {
          this.scrollToBottom();
          this.isFirstLoad = false;
        });
        return;
      }
      this.finishRequest();
      // 新协议下流式文本只累加在 streamingMessage
      this.finalMessage = this.streamingMessage;
      console.log(this.finalMessage,'this.finalMessage')

      // 从本轮完整文本提取活动标识：后端在创建成功的回复末尾注入
      // [[activity_id:<id>]] [[activity_key:<key>]] 标记。
      // 只接受后端注入的完整双右括号标记，避免把普通文本误判为活动编号。
      const activityId = extractAiActivityId(this.finalMessage);
      const activityKey = extractAiActivityKey(this.finalMessage);
      if (activityId || activityKey) {
        this.createdActivityId = activityId;
        this.createdActivityKey = activityKey;
        this.showViewActivityBtn = true;
        this.showViewActivityBtnIndex = this.chatList.length - 1;
        // 从显示文本中删掉两类标记（连同前后空白），用户不可见
        const cleaned = stripAiActivityMarkers(this.finalMessage);
        this.finalMessage = cleaned;
        this.streamingMessage = cleaned;
        this.updateLastMessage(cleaned);
      }

      // 草稿消息检测：AI 回复含草稿关键词时，显示「确认创建/重新生成」按钮
      if (this.isDraftMessage(this.finalMessage)) {
        this.showConfirmBtn = true;
        this.showConfirmBtnIndex = this.chatList.length - 1;
      }

      // 重置轮次状态
      this.streamingMessage = "";
      this.lastMessageIndex = -1;
      this.$nextTick(() => {
        this.scrollToBottom();
        this.isFirstLoad = false;
      });
    },
    // 更新最后一条消息的内容
    updateLastMessage(content, options = {}) {
      if (
        this.lastMessageIndex >= 0 &&
        this.lastMessageIndex < this.chatList.length
      ) {
        const message = this.chatList[this.lastMessageIndex];
        message.content = content;
        if (options.isThinkingPlaceholder !== undefined) {
          message.isThinkingPlaceholder = options.isThinkingPlaceholder;
        }
        if (!message.isSelf && message.type === "text") {
          message.richTextContent = message.isThinkingPlaceholder
            ? ""
            : renderAiMarkdown(content);
        }

        // 只有在非手动滚动状态下才滚动到底部
        if (!this.isManualScroll) {
          this.scrollToBottom();
        }
      }
    },
    addQuickMessage(message) {
      if (this.isActionLocked) return;
      if (!this.socketTask) {
        this.showToast("连接未就绪，请稍后重试");
        return;
      }
      this.startRequest();
      // 发送消息到窗口
      this.addMessage(message, true);
      this.prepareThinkingPlaceholder();
      // 发送消息到 socket（纯文本协议）
      if (!this.sendChat(message)) {
        this.removeThinkingPlaceholder();
        this.finishRequest();
        return;
      }
      // 重置滚动状态
      this.isManualScroll = false;
      this.isAutoScroll = true;
      this.$nextTick(() => {
        this.scrollToBottom();
      });
    },
    /** 点击"查看活动详情"按钮，跳转到活动详情页 */
    // 详情页 /activityDetails 只按 query.alias 读取活动 key（同 folderDetails 等入口）。
    // 新协议后端注入 [[activity_key:<key>]]，优先使用；旧协议只在 [[activity_id:<id>]]
    // 标记里给值时兜底使用 id 值，参数名必须是 alias。
    viewActivityDetail() {
      const activityKey = this.createdActivityKey || this.createdActivityId;
      if (!activityKey) {
        this.showToast("活动Key不存在");
        return;
      }
      this.$router
        .push({
          path: "/activityDetails",
          query: {
            alias: String(activityKey),
          },
        })
        .catch(() => {});
    },
    // 检测 AI 回复是否是"草稿待确认"消息
    isDraftMessage(text) {
      if (!text || typeof text !== "string") return false;
      // 判定 AI 回复是否为"草稿待确认"状态，命中即显示【确认创建】【重新生成】按钮。
      // 后端 prompt 约定的标准措辞（已生成创建草稿 等）+ 模型实际可能输出的引导确认措辞
      // （是否需要调整 / 直接发布 / 请确认 / 草稿 等）都要覆盖，避免按钮不显示。
      return /已生成创建草稿|已更新创建草稿|已为您准备好创建草稿|确认后我再(正式)?创建|确认后我再提交|是否需要调整|直接发布|创建草稿|生成草稿|草稿.{0,4}确认|确认.{0,4}草稿/.test(
        text
      );
    },
    // 点击"确认创建"按钮：发送固定文字，等同用户手动打字
    confirmCreateDraft() {
      // AI 响应期间置灰防连点（按钮不消失，只是禁用）
      if (this.isRequestPending) return;
      const message = "确认创建";
      // 顺序对齐 handleSend：先加用户消息 → 占位提示 → 发送；失败则清理占位
      // 只置灰（isRequestPending），不调 startRequest，避免它清掉 showConfirmBtn 导致按钮消失
      this.isRequestPending = true;
      this.addMessage(message, true);
      this.prepareThinkingPlaceholder();
      if (!this.sendChat(message)) {
        this.removeThinkingPlaceholder();
        this.finishRequest();
        return;
      }
      this.$nextTick(() => {
        this.scrollToBottom();
      });
    },
    // 点击"重新生成"按钮：发送固定文字"重新生成"，等同用户手动打字
    regenerateDraft() {
      // AI 响应期间置灰防连点（按钮不消失，只是禁用）
      if (this.isRequestPending) return;
      const message = "重新生成";
      // 顺序对齐 handleSend：先加用户消息 → 占位提示 → 发送；失败则清理占位
      // 只置灰（isRequestPending），不调 startRequest，避免它清掉 showConfirmBtn 导致按钮消失
      this.isRequestPending = true;
      this.addMessage(message, true);
      this.prepareThinkingPlaceholder();
      if (!this.sendChat(message)) {
        this.removeThinkingPlaceholder();
        this.finishRequest();
        return;
      }
      this.$nextTick(() => {
        this.scrollToBottom();
      });
    },
    copyMessage(content) {
      const text = String(content || "");
      const succeed = () => this.showToast("复制成功");
      const fail = () => this.showToast("复制失败");
      // clipboard API 仅安全上下文可用（https/localhost），非安全上下文回退 execCommand
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text).then(succeed).catch(fail);
        return;
      }
      try {
        const textarea = document.createElement("textarea");
        textarea.value = text;
        textarea.style.position = "fixed";
        textarea.style.opacity = "0";
        document.body.appendChild(textarea);
        textarea.select();
        const copied = document.execCommand("copy");
        document.body.removeChild(textarea);
        if (copied) {
          succeed();
        } else {
          fail();
        }
      } catch (error) {
        fail();
      }
    },
    // 流式期间用 50ms 轮询检测「缓冲长度不再增长」来停止自动滚动
    startScrollPolling() {
      if (this.scrollTimer) {
        clearInterval(this.scrollTimer);
      }

      this.lastMessageLength = this.streamingMessage.length;

      this.scrollTimer = setInterval(() => {
        if (this.streamingMessage.length === this.lastMessageLength) {
          this.stopScrollPolling();
          return;
        }

        this.lastMessageLength = this.streamingMessage.length;

        // 只有在非手动滚动状态下才滚动到底部
        if (!this.isManualScroll) {
          this.$nextTick(() => {
            this.scrollToBottom();
          });
        }
      }, 50);
    },
    stopScrollPolling() {
      if (this.scrollTimer) {
        clearInterval(this.scrollTimer);
        this.scrollTimer = null;
      }
    },
    startRequest() {
      this.isRequestPending = true;
      this.showConfirmBtn = false;
      this.showConfirmBtnIndex = 0;
      this.showViewActivityBtn = false;
    },
    finishRequest() {
      this.isRequestPending = false;
    },
    resetScrollState() {
      this.isManualScroll = false;
      this.isAutoScroll = true;
      this.scrollToBottom();
    },
  },
};
</script>

<style lang="scss" scoped>
.outBox {
  width: 100%;
  /* 高度补偿 .page-content 上内边距 69px + 底部版权条预留 60px，
     使输入区底边正好贴住页脚（.footer，高 60px，视口底对齐） */
  height: calc(100vh - 129px);
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: space-between;
  align-items: stretch;
}
.box-1 {
  width: 100%;
  height: 0;
  flex: 1 0 auto;
  box-sizing: border-box;
  padding: 10px;
}
.chat-messages {
  height: 100%;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
}
#msglist {
  flex: 1;
  overflow-y: auto;
  height: 100%;
  padding-bottom: 20px;
}
.chat-left-box {
  margin-bottom: 20px;
}
.tx-left {
  margin-right: 10px;
}
.tx {
  img {
    height: 40px;
    width: 40px;
    border-radius: 10px;
  }
}
.user-name {
  font-size: 14px;
  color: #3c4252;
  margin-bottom: 10px;
}
.content-box-left {
  width: 520px;
  max-width: 100%;
  background-color: white;
  box-sizing: border-box;
  padding: 10px;
  border-radius: 0px 10px 10px 10px;
}
.content-box-right {
  background-color: #1877ff;
  color: white;
  box-sizing: border-box;
  padding: 10px;
  border-radius: 10px 0px 10px 10px;
  word-break: break-all;
  max-width: 520px;
}
.chat-content-right {
  margin-right: 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.chat-right-box {
  margin-bottom: 20px;
}
.user-message-content {
  font-size: 15px;
  text-align: left;
  line-height: 21px;
  word-break: break-all;
  white-space: break-spaces;
}
.copy-btn-wrapper {
  margin-top: 4px;
  font-size: 12px;
  color: #7a8699;
  cursor: pointer;
  user-select: none;
  &:hover {
    color: #1877ff;
  }
}
/* 查看活动详情按钮 */
.view-activity-btn {
  margin-top: 10px;
  width: 100%;
  height: 38px;
  background-color: #1877ff;
  color: #ffffff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  user-select: none;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  transition: background-color 0.15s ease;
  .view-activity-icon {
    margin-right: 6px;
  }
  .view-activity-arrow {
    font-size: 14px;
    color: #ffffff;
    margin-left: 4px;
  }
  &:hover {
    background-color: #1568d6;
  }
}
/* 草稿确认创建 / 重新生成 按钮并排容器 */
.draft-action-btns {
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  gap: 10px;
}
.confirm-create-btn {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 38px;
  border-radius: 5px;
  background: #1877ff;
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
  box-sizing: border-box;
  cursor: pointer;
  transition: background-color 0.15s ease;
  &:hover {
    background-color: #1568d6;
  }
}
/* 草稿重新生成按钮（与确认创建等大并排，蓝色文字+蓝色边框+白底） */
.regenerate-btn {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 38px;
  border-radius: 5px;
  background: #ffffff;
  border: 1px solid #3c78ff;
  color: #3c78ff;
  font-size: 14px;
  font-weight: 500;
  box-sizing: border-box;
  cursor: pointer;
}
/* 草稿按钮置灰态：AI 响应期间禁用防连点，按钮不消失只变灰 */
.draft-btn-disabled {
  opacity: 0.5;
  pointer-events: none;
}
.each-item {
  color: #3c78ff;
  margin-bottom: 10px;
  cursor: pointer;
}
.aPoint {
  color: #3c78ff;
  margin-right: 5px;
  font-size: 12px;
}
.point-after {
  .pa-txt {
    font-size: 14px;
    text-decoration: underline;
  }
  .quick-arrow {
    color: #3c78ff;
    font-size: 12px;
    margin-left: 4px;
  }
  &.is-disabled {
    opacity: 0.5;
    pointer-events: none;
  }
}
.input-container {
  background: #fff;
  padding: 10px 10px 6px;
  border-top: 1px solid #eee;
}
.input-wrapper {
  display: flex;
  align-items: flex-end;
  gap: 10px;
  background-color: #fff;
}
.text-input {
  flex: 1;
  ::v-deep .el-textarea__inner {
    background: #f7f7f7;
    border-radius: 4px;
    border-color: transparent;
    font-size: 14px;
    line-height: 21px;
    padding: 8px 10px;
    resize: none;
  }
}
.send-btn {
  flex-shrink: 0;
}
/* 底部免责声明 */
.ai-tip {
  margin-top: 6px;
  text-align: center;
  .ai-tip-text {
    font-size: 12px;
    color: #a3a7ad;
  }
}
/* flex 布局 */
.flex-depart-left {
  display: flex;
  align-items: center;
}

.flex-depart-center {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.flex-depart-top {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}
.flex-depart-right-top {
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
}
.flex-depart-left-center {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
</style>

<style lang="scss">
/* AI 气泡 markdown 渲染样式（v-html 内容不受 scoped 作用域约束，统一以
   .markdown-rich-text 前缀手动限定）。视觉基线对齐小程序 30rpx/46rpx 换算。 */
.markdown-rich-text {
  font-size: 15px;
  line-height: 23px;
  text-align: left;
  color: #3c4252;
  word-break: break-word;
  overflow-x: auto;

  &.is-thinking-placeholder {
    color: #7a8699;
  }

  p {
    margin: 0 0 8px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 12px 0 8px;
    font-weight: 600;
    color: #1f2430;
    &:first-child {
      margin-top: 0;
    }
  }
  h1 {
    font-size: 20px;
  }
  h2 {
    font-size: 18px;
  }
  h3 {
    font-size: 16px;
  }
  h4,
  h5,
  h6 {
    font-size: 15px;
  }
  strong {
    font-weight: 600;
  }
  a {
    color: #1877ff;
    text-decoration: underline;
  }
  ul,
  ol {
    margin: 0 0 8px;
    padding-left: 1.5em;
  }
  li {
    margin: 2px 0;
  }
  li.ai-md-task {
    list-style: none;
    input[type="checkbox"] {
      margin-right: 6px;
      vertical-align: middle;
    }
  }
  code {
    background: #f2f4f7;
    border-radius: 3px;
    padding: 1px 5px;
    font-family: Consolas, Menlo, Monaco, "Courier New", monospace;
    font-size: 13px;
    color: #c7254e;
  }
  pre {
    background: #f5f7fa;
    border-radius: 5px;
    padding: 10px 12px;
    overflow-x: auto;
    margin: 0 0 8px;
    code {
      background: none;
      padding: 0;
      color: #3c4252;
      font-size: 13px;
      white-space: pre;
    }
  }
  pre.ai-md-math {
    background: #f5f7fa;
  }
  code.ai-md-formula {
    color: #0b6fa4;
  }
  blockquote {
    margin: 0 0 8px;
    padding: 6px 10px;
    border-left: 3px solid #dcdfe6;
    background: #f7f8fa;
    color: #5a6474;
    p {
      margin: 0;
    }
  }
  table {
    width: 100%;
    border-collapse: collapse;
    margin: 0 0 8px;
    th,
    td {
      border: 1px solid #e8ebf0;
      padding: 6px 10px;
      font-size: 14px;
      text-align: left;
    }
    th {
      background: #f5f7fa;
      font-weight: 600;
    }
  }
  mark {
    background: #fff3c4;
    padding: 0 2px;
  }
  ins {
    text-decoration: underline;
  }
  sub,
  sup {
    font-size: 11px;
  }
  hr {
    border: none;
    border-top: 1px solid #e8ebf0;
    margin: 10px 0;
  }
  img {
    max-width: 100%;
  }
}
</style>
